import { render } from "./changepassword.vue?vue&type=template&id=5e4a176c&scoped=true"
import script from "./changepassword.vue?vue&type=script&lang=js"
export * from "./changepassword.vue?vue&type=script&lang=js"

import "./changepassword.vue?vue&type=style&index=0&id=5e4a176c&scoped=true&lang=css"

import exportComponent from "E:\\Proj\\Apps\\Stock\\vuestock\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4a176c"]])

export default __exports__